import { Component, Input } from '@angular/core';
import { UserExtensions } from '../../core/extension-methods/user-extensions';
import { UserModel } from '../../core/models/interfaces/user.model';

@Component({
    selector: 'user-avatar',
    imports: [],
    templateUrl: './user-avatar.component.html',
    styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  @Input() public user!: UserModel;
  @Input() public lastUser: boolean = false;
  @Input() public showShadow: boolean = false;

  backgroundColors: string[] = ['blue', 'green', 'red', 'purple', 'orange'];

  getInitials(): string {
    return UserExtensions.generateInitials(
      this.user.firstName,
      this.user.lastName
    );
  }

  getBackgroundColor(): string {
    const initialsNumber = this.getInitials()
      .split('')
      .reduce((a, b) => a + b.charCodeAt(0), 0);
    return this.backgroundColors[initialsNumber % this.backgroundColors.length];
  }
}
